import React from 'react';
import SocialIcons from 'js/reusable-components/Social';
import 'js/teamSportIndex/components/social.scss';

export default function Social(props) {
  return (
    <div id="social">
      <div className="mainWidth">
        <div className="innerMainWidth social">
          <div>
            <h2 className="title">
              {props?.common?.socialmediatitle || '#Unisportlife'}
            </h2>
            <p
              className="text"
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: props?.common?.instagramtextnew || ''
              }}
            />

            <SocialIcons
              iconsToShow={[
                'YouTube',
                'Instagram',
                'Facebook',
                'TikTok',
                'SnapChat'
              ]}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
